import { render, staticRenderFns } from "./TensoLogo.vue?vue&type=template&id=0568abbc&scoped=true&"
import script from "./TensoLogo.vue?vue&type=script&lang=js&"
export * from "./TensoLogo.vue?vue&type=script&lang=js&"
import style0 from "./TensoLogo.vue?vue&type=style&index=0&id=0568abbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568abbc",
  null
  
)

export default component.exports